import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getLookupLabel',
  pure: false
})
export class GetLookupLabelPipe implements PipeTransform {
  transform(key: any, lookupValues: any[], lookupKey: any, lookupLabel: any, getAllItems?: boolean): any {
    if (key == null || key == undefined || !lookupValues || lookupValues.length == 0)
      return key;
    if (getAllItems == true) {
      let list = [];
      if (key.length > 1) {
        for (var i = 0; i < key.length; i++) {
          let data = lookupValues.filter(item => item && item[lookupKey] == key[i][lookupKey]);
          for (var j = 0; j < data.length; j++) {
            list.push(data[j][lookupLabel])
          }
        }
      }
      else {
        let data = lookupValues.filter(item => item && item[lookupKey] == key[lookupKey]);
        for (var i = 0; i < data.length; i++) {
          list.push(data[i][lookupLabel])
        }
      }
      return list;
    }
    else
      return lookupValues.filter(item => item && item[lookupKey] == key)[0][lookupLabel];
  }
}
